import React from "react";
import {connect} from "react-redux";
import {Dialog, CircularProgress} from "@material-ui/core";
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";



interface IProps {
    open: boolean
}

interface IState {
}

class Loading extends React.Component<IProps, IState>{

    state:IState = {
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                PaperProps={{style: {display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: "transparent"}}}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: "center",
                        height: 200,
                        width: 200,
                        overflow: "hidden",
                        backgroundColor: "transparent"
                    }}
                >
                    <CircularProgress
                        style={{
                            height: 160,
                            width: 160,
                            color: "#b43333"
                        }}
                    />
                </div>

            </Dialog>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    open: state.navegacion.dialogs.loading
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Loading);
